// An in-page "are you sure?" for Quote Assessment. It replaces the browser's confirm(),
// which blocks page automation (the quote-assessment runbook drives this page from
// Chrome) and can't be styled. The caller owns what happens on confirm.
export default function ConfirmActionDialog({ title, message, confirmLabel = 'Confirm', danger = false, busy, onCancel, onConfirm }) {
    return (
        <div className="modal-overlay">
            <div className="modal-content qa-pair-modal" role="dialog" aria-modal="true" aria-label={title}
                onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{title}</h2>
                    <button className="modal-close" aria-label="Close" onClick={onCancel}>&times;</button>
                </div>
                <div className="modal-body-scroll">
                    <div className="qa-pair-explain" style={{ whiteSpace: 'pre-line' }}>{message}</div>
                </div>
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
                    <button className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`} onClick={onConfirm} disabled={busy}>
                        {busy ? '…' : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
